interface FileTypeData {
  id?: number;
  fileFamilyId?: number;
  name?: string;
  extension?: string;
  mimeType?: string;
}

export class FileType {
  public static readonly ID_OTHER: number = 1;
  public static readonly ID_AAC: number = 2;
  public static readonly ID_AVI: number = 3;
  public static readonly ID_CSV: number = 4;
  public static readonly ID_DOC: number = 5;
  public static readonly ID_DOCX: number = 6;
  public static readonly ID_GIF: number = 7;
  public static readonly ID_JPEG: number = 8;
  public static readonly ID_JPG: number = 9;
  public static readonly ID_JSON: number = 10;
  public static readonly ID_MID: number = 11;
  public static readonly ID_MIDI: number = 12;
  public static readonly ID_MPEG: number = 13;
  public static readonly ID_PNG: number = 14;
  public static readonly ID_PDF: number = 15;
  public static readonly ID_PPT: number = 16;
  public static readonly ID_PPTX: number = 17;
  public static readonly ID_RAR: number = 18;
  public static readonly ID_RTF: number = 19;
  public static readonly ID_SVG: number = 20;
  public static readonly ID_WEBA: number = 21;
  public static readonly ID_WEBM: number = 22;
  public static readonly ID_WEBP: number = 23;
  public static readonly ID_XLS: number = 24;
  public static readonly ID_XLSX: number = 25;
  public static readonly ID_XML: number = 26;
  public static readonly ID_ZIP: number = 27;
  public static readonly ID_3GPA: number = 28;
  public static readonly ID_3GPV: number = 29;
  public static readonly ID_7Z: number = 30;
  public static readonly ID_MP3: number = 31;
  public static readonly ID_MP4: number = 32;
  public static readonly ID_MKV: number = 33;
  public static readonly ID_FOLDER: number = 34;

  public static getNonTranslatableFields(): string[] { return ['id', 'fileFamilyId', 'extension', 'mimeType']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'fileFamilyId', 'name', 'extension', 'mimeType']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  fileFamilyId?: number;
  name?: string;
  extension?: string;
  mimeType?: string;


  public static fromAPI(data: FileTypeData, translationsData: any[]): FileType {
    let translationData:any = {};
    for (let i = 0; i < translationsData.length; i++) {
      if (translationsData[i]['fileTypeId'] === data['id']) {
        translationData = translationsData[i];
        i = translationsData.length;
      }
    }
    return new FileType({
      id: data.id,
      fileFamilyId: data.fileFamilyId,
      name: translationData.name ?? data.name,
      extension: data.extension,
      mimeType: data.mimeType
    });
  }

  public static fromAPIList(data: FileTypeData[], translationsData: any[]): FileType[] {
    return data.map((item: FileTypeData) => FileType.fromAPI(item, translationsData));
  }

  constructor({id, fileFamilyId, name, extension, mimeType} : FileTypeData) {
    this.id = id;
    this.fileFamilyId = fileFamilyId;
    this.name = name;
    this.extension = extension;
    this.mimeType = mimeType;
  }

 public toJson(): FileTypeData {
    return {
      id: this.id,
      fileFamilyId: this.fileFamilyId,
      name: this.name,
      extension: this.extension,
      mimeType: this.mimeType
    };
 }
}
